import { environment } from '~env/environment';

export const API_PRODUCTS_LIST_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/search`

export const API_PRODUCTS_LIST_PROXY_ROUTE = () => `${environment.svcStoryblokBridgeBaseUrl()}/api/v3/search`
export const API_BLOOMREACH_RECOMMENDATIONS_PRODUCTS_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/recommendations/{CAMPAIGN_ID}`;
export const API_G_RECOMMENDATIONS_PRODUCTS_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/recommendations/gc/recommended-for-you`;

export const API_SEARCH_ATTRBIUTE_ROUTE_V3 = () => `${environment.svcSearch2BaseUrl()}/api/v3/search-attribute`

// STORYBLOK API URL
export const SB_CATEGORY_PLP_PAGE_ROUTE = '{market}/c';
export const SB_CUSTOM_PLP_PAGE_ROUTE = '{market}/landing';
